import { FormattedMessage } from 'react-intl';

interface IProps {
  onClose?: () => void;
  onClick?: () => void;
}

const CartDeleteModal = ({ onClose, onClick }: IProps) => {
  return (
    <div className="fixed inset-0 w-full h-full bg-black/80 flex justify-center items-center z-[11]">
      <div className="w-[571px] h-[292px] rounded-[20px] bg-white text-center flex flex-col justify-between px-[60px] pt-[48px] pb-[40px]">
        <h3 className="text-[30px] leading-9 font-extrabold">
          <FormattedMessage
            id="cart_delete_modal_title"
            defaultMessage="Are you sure you want to delete all items in your cart?"
          />
        </h3>
        <div className="flex gap-[12px]">
          <button
            className="flex-1 flex justify-center items-center h-[66px] rounded-[20px] bg-[#f2f2f2] text-[18px] font-bold data-[primary=true]:bg-[#ff6060] data-[primary=true]:text-white"
            onClick={() => onClose?.()}
          >
            <FormattedMessage id="cart_delete_modal_onClose_text" defaultMessage="Stay" />
          </button>
          <button
            className="flex-1 flex justify-center items-center h-[66px] rounded-[20px] bg-[#f2f2f2] text-[18px] font-bold data-[primary=true]:bg-[#ff6060] data-[primary=true]:text-white"
            data-primary
            onClick={() => onClick?.()}
          >
            <FormattedMessage id="cart_delete_modal_onClick_text" defaultMessage="Delete all" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartDeleteModal;
